<template>
    <div>
        <h4>&nbsp;{{channelUptime}}</h4>
    </div>

</template>
<script>

    export default {
        props: {
            startTime: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                updateUptimeTimer: '',
                channelUptime: ''
            }
        },
        methods: {
            setUptime() {
                const uptime = this.moment.duration(this.moment().diff(this.moment(this.startTime)))
                this.channelUptime = ((uptime.days() > 0) ? (uptime.days() + 'd ') : '') + ('0' + uptime.hours()).slice(-2) + ':' + ('0' + uptime.minutes()).slice(-2) + ':' + ('0' + uptime.seconds()).slice(-2)
            }
        },
        beforeDestroy() {
            clearInterval(this.updateUptimeTimer)
        },
        mounted() {
            this.updateUptimeTimer = setInterval(() => { this.setUptime() }, 1000)
        }
    }

</script>
